import React, { useState } from 'react';
import Button from './Button';
const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    // Form validation
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setError('Please fill in all required fields');
      setIsSubmitting(false);
      return;
    }
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email address');
      setIsSubmitting(false);
      return;
    }
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
    }, 1500);
  };
  return <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-32">
      {isSubmitted ? <div className="text-center py-8 animate-fade-in" data-id="element-33">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100" data-id="element-34">
            <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-35">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-36" />
            </svg>
          </div>
          <h3 className="mt-3 text-lg font-medium text-gray-900" data-id="element-37">
            Thank you for your message!
          </h3>
          <p className="mt-2 text-sm text-gray-600" data-id="element-38">
            I'll get back to you as soon as possible.
          </p>
        </div> : <form onSubmit={handleSubmit} className="animate-fade-in" data-id="element-39">
          {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md border border-red-200" data-id="element-40">
              {error}
            </div>}
          <div className="mb-4" data-id="element-41">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-42">
              Name <span className="text-red-500" data-id="element-43">*</span>
            </label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500" aria-required="true" data-id="element-44" />
          </div>
          <div className="mb-4" data-id="element-45">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-46">
              Email <span className="text-red-500" data-id="element-47">*</span>
            </label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500" aria-required="true" data-id="element-48" />
          </div>
          <div className="mb-4" data-id="element-49">
            <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-50">
              Subject <span className="text-red-500" data-id="element-51">*</span>
            </label>
            <select id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500" aria-required="true" data-id="element-52">
              <option value="" data-id="element-53">Select a subject</option>
              <option value="Job Opportunity" data-id="element-54">Job Opportunity</option>
              <option value="Project Collaboration" data-id="element-55">
                Project Collaboration
              </option>
              <option value="Speaking Engagement" data-id="element-56">Speaking Engagement</option>
              <option value="Other" data-id="element-57">Other</option>
            </select>
          </div>
          <div className="mb-4" data-id="element-58">
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-59">
              Message <span className="text-red-500" data-id="element-60">*</span>
            </label>
            <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500" aria-required="true" data-id="element-61" />
          </div>
          <div className="mt-6" data-id="element-62">
            <Button type="submit" variant="primary" size="lg" className="w-full" aria-label={isSubmitting ? 'Sending message...' : 'Send message'} data-id="element-63">
              {isSubmitting ? <span className="flex items-center justify-center" data-id="element-64">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-65">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-66"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-67"></path>
                  </svg>
                  Sending...
                </span> : 'Send Message'}
            </Button>
          </div>
        </form>}
    </div>;
};
export default ContactForm;